var path = 'public/app/features/panel/partials/query_editor_row.html';
var html = "<div ng-transclude class=gf-form-query-content></div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;